import React, { useState, useEffect } from "react";

import { showGrade } from "../../../../utils/textUtils";

import ClassMoreButton from "./ClassMoreButton";
import { Button } from "../../../../components/Button";
import { LevelCreateModal } from "./LevelCreateModal";
import DeleteStudentLevelButton from "./DeleteStudentLevelButton";

const LevelList = ({ levels, allStudentList, setStudentList }) => {
  const [expandedLevels, setExpandedLevels] = useState({});
  const [isExpandedAll, setIsExpandedAll] = useState(false);
  const [isLevelModalOpen, setIsLevelModalOpen] = useState(false);
  const [editLevelId, setEditLevelId] = useState(null);
  const [selectedParams, setSelectedParams] = useState({
    levelId: null,
    studentId: null,
  });
  const [groupedStudents, setGroupedStudents] = useState({
    unassigned: { name: "클래스 없음", students: [] },
  });

  const handleToggle = (levelId) => {
    setExpandedLevels((prev) => ({
      ...prev,
      [levelId]: !prev[levelId],
    }));
  };

  const expandAll = (bool) => {
    setExpandedLevels(
      levels.reduce(
        (acc, level) => {
          return { ...acc, [level.id]: bool };
        },
        { unassigned: bool }
      )
    );
    setIsExpandedAll(bool);
  };

  const handleClickStudent = (student) => {
    if (selectedParams.studentId === student.id) {
      setSelectedParams({ levelId: null, studentId: null });
    } else {
      setSelectedParams({ levelId: null, studentId: student.id });
    }
  };

  const handleClickAllStudents = (levelId) => {
    if (selectedParams.levelId === levelId) {
      setSelectedParams({ levelId: null, studentId: null });
    } else {
      setSelectedParams({ levelId, studentId: null });
    }
  };

  useEffect(() => {
    if (selectedParams.levelId) {
      setStudentList(groupedStudents[selectedParams.levelId]?.students);
    } else if (selectedParams.studentId) {
      setStudentList(
        allStudentList.filter(
          (currentStudent) => currentStudent.id === selectedParams.studentId
        )
      );
    } else {
      setStudentList(allStudentList);
    }
  }, [selectedParams]);

  useEffect(() => {
    const updatedGroupedStudents = levels.reduce(
      (acc, level) => {
        acc[level.id] = { name: level.name, students: [] };
        return acc;
      },
      { unassigned: { name: "클래스 없음", students: [] } }
    );

    allStudentList.forEach((student) => {
      if (student.level_list && student.level_list.length > 0) {
        student.level_list.forEach((level) => {
          updatedGroupedStudents[level.id]?.students.push(student);
        });
      } else {
        updatedGroupedStudents.unassigned.students.push(student);
      }
    });

    setGroupedStudents(updatedGroupedStudents);
  }, [levels, allStudentList]);

  const styles = {
    classListContainer: {
      width: "250px",
      border: "1px solid #EBEBEB",
      borderRight: "none",
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#fff",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      margin: "10px",
    },
    addButton: {
      padding: "5px 15px",
      backgroundColor: "#fff",
      border: "1px solid #000",
      borderRadius: "5px",
      cursor: "pointer",
    },
    classList: {
      listStyle: "none",
      padding: "0px",
      margin: "0px",
      overflow: "auto",
    },
    classDetail: {
      color: "#737373",
    },
    classHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "10px",
      border: "none",
      fontSize: "16px",
      gap: "10px",
    },
    studentList: {
      listStyle: "none",
      padding: 0,
      margin: 0,
      overflow: "hidden",
      maxHeight: "0",
      transition: "max-height 0.3s ease, opacity 0.3s ease",
      opacity: 0,
      fontSize: "14px",
    },
    studentListVisible: {
      maxHeight: "none",
      opacity: 1,
    },
    studentItem: {
      display: "flex",
      padding: "8px 10px",
      backgroundColor: "#fff",
      color: "#737373",
      border: "none",
      marginTop: "5px",
    },
  };

  return (
    <div style={styles.classListContainer}>
      <div
        style={{
          ...styles.classHeader,
          borderBottom: "1px solid #EBEBEB",
        }}
      >
        <span>전체 {allStudentList.length}명</span>
        <Button
          backgroundColor="#F6F8FA"
          color="#737373"
          border="1px solid #EBEBEB"
          fontSize="14px"
          padding="5px 15px"
          onClick={() => expandAll(!isExpandedAll)}
        >
          {isExpandedAll ? "모두 닫기" : "모두 열기"}
        </Button>
      </div>
      <ul style={styles.classList}>
        {Object.entries(groupedStudents).map(
          ([levelId, { name, students }]) => (
            <li key={levelId}>
              <div
                style={{
                  backgroundColor: expandedLevels[levelId] ? "#EBEBEB" : "#fff",
                  color: expandedLevels[levelId] ? "#000" : "#737373",
                  ...styles.classHeader,
                }}
                onClick={() => handleToggle(levelId)}
              >
                <span>{name}</span>
                <span style={styles.classDetail}>{students.length}명</span>
                <div
                  style={{ marginLeft: "auto" }}
                  onClick={(event) => event.stopPropagation()}
                >
                  <ClassMoreButton
                    levelId={levelId}
                    levelName={name}
                    editLevelId={editLevelId}
                    setEditLevelId={setEditLevelId}
                    groupedStudents={groupedStudents}
                  />
                </div>
              </div>
              <ul
                style={{
                  ...styles.studentList,
                  ...(expandedLevels[levelId] ? styles.studentListVisible : {}),
                }}
              >
                <li
                  key={"group_" + levelId}
                  style={{
                    ...styles.studentItem,
                    color:
                      selectedParams.levelId === levelId ? "#000" : "#737373",
                    fontWeight: "bold",
                  }}
                  onClick={() => handleClickAllStudents(levelId)}
                >
                  전체 학생
                </li>
              </ul>
              <ul
                style={{
                  ...styles.studentList,
                  ...(expandedLevels[levelId] ? styles.studentListVisible : {}),
                }}
              >
                {students.map((student) => (
                  <li
                    key={student.id}
                    style={{
                      ...styles.studentItem,
                      color:
                        selectedParams.studentId === student.id
                          ? "#000"
                          : "#737373",
                    }}
                    onClick={() => handleClickStudent(student)}
                  >
                    {student.name} ({showGrade(student.grade)})
                    {levelId !== "unassigned" && (
                      <div style={{ marginLeft: "auto" }}>
                        <DeleteStudentLevelButton
                          student={student}
                          levelId={levelId}
                          name={name}
                        />
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </li>
          )
        )}
      </ul>
      <div style={styles.buttonContainer}>
        <button
          style={styles.addButton}
          onClick={() => setIsLevelModalOpen(true)}
        >
          + 반 추가
        </button>
      </div>

      {isLevelModalOpen && (
        <LevelCreateModal setIsLevelModalOpen={setIsLevelModalOpen} />
      )}
    </div>
  );
};

export default LevelList;
